import { Button } from "@progress/kendo-react-buttons";
import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

const DeleteDialog = (props) => {
  return (
    <Dialog title={"Please confirm"} onClose={props.onCancel}>
      <p
        style={{
          margin: "25px",
          textAlign: "center",
        }}
      >
        Are you sure you want to delete?
      </p>
      <DialogActionsBar>
        <Button onClick={props.onCancel}>{"Cancel"}</Button>
        <Button
          type={"submit"}
          themeColor={"primary"}
          onClick={() => props.onDelete(props.item)}
        >
          {"Delete"}
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default DeleteDialog;
